/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.6.0",
  "gitBuildTime": "2026-01-23T15:01:21.736Z",
  "gitBuildVersion": "2.6.0",
  "gitCommitId": "9da7a37",
  "gitCommitIdFull": "9da7a379f807024d33e68e0b7afdb3d40a84615f",
  "gitCommitTime": "2026-01-22T20:12:10.000Z",
  "version": "2.6.0-2026-01-22T20:12:10.000Z-(9da7a37)"
};
